import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import { CreateNewScenarioDialog } from '../../home/components';
import { Scenario } from '../../scenarios/types/scenario.model';
import { setScenario } from '../../home/store/simulator-home-slice';
import ScenarioCreateSuccessDialog from '../../home/components/scenario-create-success/scenario-create-success-dialog';
import { getAccessConfigForScenario } from '../../home/store/simulator-home-async-thunks';
import MODULE_TO_PAGE_MAP from '../../home/types/simulation-module-to-page-map';

export default function SaveAsContainer({
  disabled = false
}: {
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
}) {
  const appDispatch = useAppDispatch();
  const { sourceId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.PLANNER
  });
  const [isNewScenarioDialogOpen, setIsNewScenarioDialogOpen] = useState(false);
  const { currentScenario } = useAppSelector((state) => state.simulatorHome);

  const [isSaveAsSuccessDialogOpen, setIsSaveAsSuccessDialogOpen] =
    useState(false);

  const navigate = useNavigate();

  const handleSaveAs = () => {
    setIsNewScenarioDialogOpen(true);
  };

  const createScenarioClickHandler = (scenario: Scenario) => {
    setIsNewScenarioDialogOpen(false);
    if (scenario) {
      setIsSaveAsSuccessDialogOpen(true);
      appDispatch(setScenario(scenario));
      appDispatch(
        getAccessConfigForScenario({ scenarioId: scenario.pk_id, sourceId })
      ).then(() => {
        setTimeout(() => {
          navigate(`/srm/simulator/${scenario.pk_id}/planner`);
        }, 2000);
      });
    }
  };

  const handleSaveAsSuccessDialogClose = () => {
    setIsSaveAsSuccessDialogOpen(false);
  };

  return (
    <>
      <Button disabled={disabled} variant='outlined' onClick={handleSaveAs}>
        Save as
      </Button>
      {isNewScenarioDialogOpen ? (
        <CreateNewScenarioDialog
          isOpen={isNewScenarioDialogOpen}
          currentScenario={currentScenario}
          isEditable={false}
          isDuplicate={false}
          onClose={createScenarioClickHandler}
        />
      ) : null}
      {isSaveAsSuccessDialogOpen ? (
        <ScenarioCreateSuccessDialog
          imagePath='/static/images/success.svg'
          isOpen={isSaveAsSuccessDialogOpen}
          onClose={handleSaveAsSuccessDialogClose}
          message='Scenario Saved Successfully'
        />
      ) : null}
    </>
  );
}
